import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Graph from '../../components/Graph';
import { MdClear, MdSearch } from 'react-icons/md';
import { FaPrint } from 'react-icons/fa';
import { FaCalendarAlt,
        } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import VehActiveTravelXls from './VehActiveTravelXls';
import { useToasts } from 'react-toast-notifications';

import "./VehActiveTravel.scss";

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const VehActiveTravel = (props) => {
    const { addToast } = useToasts();
    const [totalCount, setTotalCount] = useState({});
    const [vehicleCount, setVehicleCount] = useState({});
    const [busiestDay, setBusiestDay] = useState({});
    const [modalTotal, setModalTotal] = useState({});  
    const [modalTotalVeh, setModalTotalVeh] = useState({});  
    const [modalDist, setModalDist] = useState({});  
    const [numDays, setNumDays] = useState(0);
    const [asset, setAsset] = useState();
    const [assets, setAssets] = useState([]);
    const [assetName, setAssetName] = useState();
    const [timeFrom, setTimeFrom] = useState(new Date().setHours(0,0,0));
    const [timeTo, setTimeTo] = useState(new Date().setHours(23,59,0));
    const [dateSel, setDateSel] = useState(new Date());
    const [dateSelTo, setDateSelTo] = useState(new Date());
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingCounts, setIsLoadingCounts] = useState(false);
    const [counts, setCounts] = useState([]);

	const [location, setLocation] = useState('');
	const [locationList, setLocationList] = useState([]);
	const [assetList, setAssetList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
    const chartColors = process.env.REACT_APP_CHART && process.env.REACT_APP_CHART.split(',');  
    const [error, setError] = useState('');

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy','DD/MM/YYYY, h a', 'DD-MM']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy','MM/DD/YYYY, h a', 'MM-DD']
    }

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            const data = await API.get('asset','/', params)
            data.sort((a, b) => (a.name > b.name) ? 1 : -1)

            //Get user asset list
            let user_assets = []
            if (props.user && props.user.username)
                user_assets = await API.get('user_assets','/' + props.user.username, params)

            let assetsFiltered = []
            if (user_assets && user_assets.assets){
                user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id) && x.status === 'active');
            }

            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }

        if (props.user && Object.keys(props.user).length !== 0)
            fetchAssets();

    }, [props.user]);

    // Load counts
    // Fetch hourly counts filter by asset, date and time range
    const fetchCounts = async () => {
        setIsLoadingCounts(true);
        setCounts([]);

        let result = []

        const dtF = new Date(dateSel)
        const dtT = new Date(dateSelTo)

        const dtFrom = moment.utc(dtF).local().format('YYYY-MM-DD')
        const tiFrom = moment.utc(timeFrom).local().format('HH:mm:ss');
        let  dateStart = moment(dtFrom + ' ' + tiFrom).toISOString();

        const dtTo = moment.utc(dtT).local().format('YYYY-MM-DD')
        const tiTo = moment.utc(timeTo).local().format('HH:mm:ss');
        let  dateEnd = moment(dtTo + ' ' + tiTo).toISOString();

        const diffTime = Math.abs(dtT - dtF);
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 

        setNumDays(diffDays)

        if (dateEnd >= dateStart){

            let data = []
            let active_travel = []
            let peds = []
            let bikes = []
            let moto = []
            let car = []
            let van = []
            let short_truck = []
            let med_truck = []
            let long_truck = []
            let bus = []
            let undef = []
            let vehicles = []
            if (dateEnd >= dateStart){
                const filter = asset +'?start='+ dateStart +'&end='+ dateEnd //+'&class=' //+ vehClass

                await API.get('daily_counts','/'+ filter, params)
                .then(resp => {
                    // data = resp

                    data = resp.length>0 && resp.map(item => {
                        // let vclass = []
                        active_travel = []
                        bikes = []
                        peds = []
                        moto = []
                        car = []
                        van = []
                        short_truck = []
                        med_truck = []
                        long_truck = []
                        bus = []
                        undef = []
                        vehicles = []

                        const entry = item.entries

                        Object.keys(entry).forEach((key) => {
                            if (typeof entry[key] === 'object' && entry[key] !== null) {    
                                
                                switch (key){
                                    case 'PEDESTRIAN':
                                        peds.push(entry[key]) 
                                        break;
                                    case 'BIKE':
                                        bikes.push(entry[key])
                                        break;
                                    case 'MOTORBIKE':
                                        moto.push(entry[key])
                                        break;                                   
                                    case 'CAR':
                                        car.push(entry[key])
                                        break;  
                                    case 'VAN':
                                        van.push(entry[key])
                                        break;  
                                    case 'SHORT TRUCK':
                                        short_truck.push(entry[key])
                                        break;  
                                    case 'MED TRUCK':
                                        med_truck.push(entry[key])
                                        break; 
                                    case 'LONG TRUCK':
                                        long_truck.push(entry[key])
                                        break;   
                                    case 'BUS':
                                        bus.push(entry[key])
                                        break;  
                                    default:
                                        undef.push(entry[key])
                                        break;  
                                }
                                if (key === 'PEDESTRIAN' || key === 'BIKE')
                                    active_travel.push(entry[key]) 
                                // if (key === 'PEDESTRIAN')
                                //     peds.push(entry[key]) 
                                // if (key === 'BIKE')
                                //     bikes.push(entry[key])                              
                                else
                                    vehicles.push(entry[key])                                     
                            } 
                        })  

                        return {
                            date_iso: item.date_iso,
                            active_travel: (active_travel.length>0 && active_travel.flat().reduce((a , b) => a + b)) || 0, //.reduce((a, b) => a.map((v, i) => v + b[i])),
                            peds: (peds.length>0 && peds.flat().reduce((a , b) => a + b)) || 0, 
                            bikes: (bikes.length>0 && bikes.flat().reduce((a , b) => a + b)) || 0, 
                            moto: (moto.length>0 && moto.flat().reduce((a , b) => a + b)) || 0, 
                            car: (car.length>0 && car.flat().reduce((a , b) => a + b)) || 0, 
                            van: (van.length>0 && van.flat().reduce((a , b) => a + b)) || 0, 
                            short_truck: (short_truck.length>0 && short_truck.flat().reduce((a , b) => a + b)) || 0, 
                            med_truck: (med_truck.length>0 && med_truck.flat().reduce((a , b) => a + b)) || 0, 
                            long_truck: (long_truck.length>0 && long_truck.flat().reduce((a , b) => a + b)) || 0, 
                            bus: (bus.length>0 && bus.flat().reduce((a , b) => a + b)) || 0, 
                            undef: (undef.length>0 && undef.flat().reduce((a , b) => a + b)) || 0, 
                            vehicles: (vehicles.length>0 && vehicles.flat().reduce((a , b) => a + b)) || 0 
                        }                      
                    })                   

                }).catch(error => {
                    console.log(error)
                    addToast('Error Loading Data', { appearance: 'error' });
                    setIsLoadingCounts(false);
                });

                

                const dt = []
                const at = []
                const pd = []
                const bk = []
                const mb = []
                const ca = []
                const va = []
                const st = []
                const mt = []
                const lt = []
                const bu = []
                const un = []

                const ve = []

                data.length>0 && data.map(item => {
                    dt.push(moment(new Date(item.date_iso)).format(formatDate[3]));
                    at.push(item.active_travel);
                    pd.push(item.peds);
                    bk.push(item.bikes);
                    mb.push(item.moto);
                    ca.push(item.car);
                    va.push(item.van);
                    st.push(item.short_truck);
                    mt.push(item.med_truck);
                    lt.push(item.long_truck);
                    bu.push(item.bus);
                    un.push(item.undef);
                    ve.push(item.vehicles);
                    return true;
                })

                // result.push(data)
                result.push({
                    date_iso: dt,
                    active_travel: at,
                    peds: pd,
                    bikes: bk,
                    moto: mb,
                    car: ca,
                    van: va,
                    short_truck: st,
                    med_truck: mt, 
                    long_truck: lt,
                    bus: bu,
                    undef: un,
                    vehicles: ve
                })


            } else {
                addToast('Error incorrect dates', { appearance: 'error' });
            }
        }
        // console.log(result)
        const selAsset = assets.find(x => x.id === asset)
        setAssetName(selAsset.name);
        setCounts(result);
        setIsLoadingCounts(false);
        // console.log(result)


    }

   // Load country
   useEffect(()=>{
    const fetchCountry = async () => {
        let loc = [...new Set(assets.map(item => item.country))];
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        if (loc.length === 1)
            setCountry(loc[0]);

        setCountryList(loc);
    }
    fetchCountry();

    }, [assets]);

    // Load location
    useEffect(()=>{
    const fetchLocation = async () => {
        let loc=[]
        if (country){
            loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
        }else{
            loc = [...new Set(assets.map(item => item.location))];
        }
        loc = loc.filter(item => item !== undefined);
        loc.sort((a, b) => (a > b) ? 1 : -1)
        setLocationList(loc);
    }
    fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            setAssetList(results);
        }
		handleSearch();
    }, [location, country, assets]);


    const hex2rgba = (hex, alpha = 1) => {
        const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
      };

    // VEHICLE COUNT START
    // --------------------------
    useEffect(() => {

        // Total vehicles count / hour
        const getVehicleCount = () => {

            if (counts.length >0){
                // Data Active Travel v Vehicles Graph by Day
                const data = {
                    labels: counts[0].date_iso || [],
                    datasets: [{
                        type: 'line',
                        label: 'Pedestrian',
                        data: counts[0].peds || [],
                        borderColor: chartColors[1],
                        backgroundColor: chartColors[1],
                        // borderColor:'rgba(255, 99, 132, 0.2)',
                        // backgroundColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        // stack: '1'
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        type: 'line',
                        label: 'Bikes',
                        data: counts[0].bikes || [],
                        borderColor: chartColors[5],
                        backgroundColor: chartColors[5],
                        // borderColor:'rgba(255, 99, 132, 0.2)',
                        // backgroundColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        // stack: '1'
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        type: 'line',
                        label: 'Vehicles',
                        data: counts[0].vehicles || [],
                        borderColor: chartColors[4],
                        backgroundColor: chartColors[4],
                        // borderColor:'rgba(75, 192, 192, 0.2)',
                        // backgroundColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 2,
                        // stack: '2'
                        datalabels: {
                            display: false
                        }
                    }]
                }
                // console.log(data)
                setVehicleCount(data);

                // Data Active Travel v Vehicles Graph - Total Count 
                const total_active = counts[0].active_travel.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_peds = counts[0].peds.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_bikes = counts[0].bikes.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_vehicles = counts[0].vehicles.reduce((sum, item) => {return sum = sum + item }, 0)

                const total_trips = total_active + total_vehicles

                const total = {
                    labels: ['Pedestrian', 'Bikes', 'Vehicles'],
                    datasets: [{
                        type: 'bar',
                        label: 'Total Count',
                        data: [total_peds, total_bikes, total_vehicles],
                        borderColor: [chartColors[1], chartColors[5], chartColors[4]],
                        backgroundColor: [hex2rgba(chartColors[1], 0.7), hex2rgba(chartColors[5], 0.7), hex2rgba(chartColors[4], 0.8)],
                        borderWidth: 2,
                        datalabels: {
                            color: "#57595a",
                            font: {
                                size: 16,
                                // weight: 'bold',
                            },
                            anchor: 'center',
                            clamp: 'true',
                            formatter: function(value, context) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                              }
                        }
                    },
                    ]
                }
                setTotalCount(total);

                // Data Active Travel v Vehicles Graph - Busiest Day 
                // const busy_active = counts[0].active_travel.reduce((acc, item) => acc = acc > item ? acc : item, 0);
                const busy_ped = counts[0].peds.reduce((acc, item) => acc = acc > item ? acc : item, 0);
                const busy_bikes = counts[0].bikes.reduce((acc, item) => acc = acc > item ? acc : item, 0);
                const busy_vehicles = counts[0].vehicles.reduce((acc, item) => acc = acc > item ? acc : item, 0);

                const busiest_day = {
                    labels: ['Pedestrian', 'Bikes', 'Vehicles'],
                    datasets: [{
                        type: 'bar',
                        label: 'Total Count',
                        data: [busy_ped, busy_bikes, busy_vehicles],
                        borderColor: [chartColors[1], chartColors[5], chartColors[4]],
                        backgroundColor: [hex2rgba(chartColors[1], 0.7), hex2rgba(chartColors[5], 0.7), hex2rgba(chartColors[4], 0.8)],
                        borderWidth: 2,
                        datalabels: {
                            color: "#57595a",
                            font: {
                                size: 16,
                                // weight: 'bold',
                            },
                            anchor: 'center',
                            clamp: 'true',
                            formatter: function(value, context) {
                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                              }
                        }
                    },
                    ]
                }
                setBusiestDay(busiest_day);

                // Data Active Travel v Vehicles Graph - Modal Split Total Count 
                // const modal_active = ((total_active/total_trips)*100).toFixed(2) || 0;
                const modal_peds = ((total_peds/total_trips)*100).toFixed(2) || 0;
                const modal_bikes = ((total_bikes/total_trips)*100).toFixed(2) || 0;
                const modal_vehicles = ((total_vehicles/total_trips)*100).toFixed(2) || 0;

                const modal_total = {
                    labels: ['Pedestrians', 'Bikes', 'Vehicles'],
                    datasets: [{
                        type: 'bar',
                        label: 'Percentage (%)',
                        data: [modal_peds, modal_bikes, modal_vehicles],
                        borderColor: [chartColors[1], chartColors[5], chartColors[4]],
                        backgroundColor: [hex2rgba(chartColors[1], 0.7), hex2rgba(chartColors[5], 0.7), hex2rgba(chartColors[4], 0.8)],
                        borderWidth: 2,
                        datalabels: {
                            color: "#57595a",
                            font: {
                                size: 16,
                                // weight: 'bold',
                            },
                            anchor: 'center',
                            clamp: 'true',
                            formatter: function(value, context) {
                                return value + '%';
                              }
                        }
                    },
                    ]       
                }
                setModalTotal(modal_total);

                // Data Modal Total by Veh Class
                const total_moto = counts[0].moto.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_car = counts[0].car.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_van = counts[0].van.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_short_truck = counts[0].short_truck.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_med_truck = counts[0].med_truck.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_long_truck = counts[0].long_truck.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_bus = counts[0].bus.reduce((sum, item) => {return sum = sum + item }, 0)
                const total_undef = counts[0].undef.reduce((sum, item) => {return sum = sum + item }, 0)

                const modal_moto = ((total_moto/total_vehicles)*100).toFixed(2) || 0;
                const modal_car = ((total_car/total_vehicles)*100).toFixed(2) || 0;
                const modal_van = ((total_van/total_vehicles)*100).toFixed(2) || 0;
                const modal_short_truck = ((total_short_truck/total_vehicles)*100).toFixed(2) || 0;
                const modal_med_truck = ((total_med_truck/total_vehicles)*100).toFixed(2) || 0;
                const modal_long_truck = ((total_long_truck/total_vehicles)*100).toFixed(2) || 0;
                const modal_bus = ((total_bus/total_vehicles)*100).toFixed(2) || 0;
                const modal_undef = ((total_undef/total_vehicles)*100).toFixed(2) || 0;

                let modal_total_veh = {}
                
                if (total_med_truck===0 && total_bus===0){
                    modal_total_veh = {
                        labels: ['Motorbike', 'Car', 'Van', 'Short Truck', 'Long Truck', 'Undefined'],
                        datasets: [{
                            type: 'bar',
                            label: 'Percentage (%)',
                            data: [ modal_moto, modal_car, modal_van, modal_short_truck, 
                                modal_long_truck, modal_undef],
                            borderColor: [
                                // chartColors[1], 
                                // chartColors[5], 
                                chartColors[8], 
                                chartColors[7], 
                                chartColors[4], 
                                chartColors[2], 
                                chartColors[3], 
                                chartColors[9]],
                            backgroundColor: [
                                // hex2rgba(chartColors[1], 0.7), 
                                // hex2rgba(chartColors[5], 0.7), 
                                hex2rgba(chartColors[8], 0.7), 
                                hex2rgba(chartColors[7], 0.7), 
                                hex2rgba(chartColors[4], 0.7), 
                                hex2rgba(chartColors[2], 0.7), 
                                hex2rgba(chartColors[3], 0.7), 
                                hex2rgba(chartColors[9], 0.7)
                            ],
                            borderWidth: 2,
                            datalabels: {
                                color: "#57595a",
                                font: {
                                    size: 16,
                                    // weight: 'bold',
                                },
                                anchor: 'center',
                                clamp: 'true',
                                formatter: function(value, context) {
                                    return value + '%';
                                }
                            }
                        },
                        ]       
                    }  
                }else{
                    modal_total_veh = {
                        labels: ['Motorbike', 'Car', 'Van', 'Short Truck', 'Med Truck', 'Long Truck', 'Bus', 'Undefined'],
                        datasets: [{
                            type: 'bar',
                            label: 'Percentage (%)',
                            data: [modal_moto, modal_car, modal_van, modal_short_truck, modal_med_truck, 
                                modal_long_truck, modal_bus, modal_undef],
                            borderColor: [
                                // chartColors[1], 
                                // chartColors[5], 
                                chartColors[8], 
                                chartColors[7], 
                                chartColors[4], 
                                chartColors[2], 
                                chartColors[6], 
                                chartColors[3], 
                                chartColors[0], 
                                chartColors[9]],
                            backgroundColor: [
                                // hex2rgba(chartColors[1], 0.7), 
                                // hex2rgba(chartColors[5], 0.7), 
                                hex2rgba(chartColors[8], 0.7), 
                                hex2rgba(chartColors[7], 0.7), 
                                hex2rgba(chartColors[4], 0.7), 
                                hex2rgba(chartColors[2], 0.7), 
                                hex2rgba(chartColors[6], 0.7), 
                                hex2rgba(chartColors[3], 0.7), 
                                hex2rgba(chartColors[0], 0.7), 
                                hex2rgba(chartColors[9], 0.7)
                            ],
                            borderWidth: 2,
                            datalabels: {
                                color: "#57595a",
                                font: {
                                    size: 16,
                                    // weight: 'bold',
                                },
                                anchor: 'center',
                                clamp: 'true',
                                formatter: function(value, context) {
                                    return value + '%';
                                }
                            }
                        },
                        ]       
                    }                    
                }
                setModalTotalVeh(modal_total_veh);

                // Data Active Travel v Vehicles - Modal Distribution
                // const modal_dist_active = counts[0].active_travel.map((item,i) => (Math.round((item/(item + counts[0].vehicles[i]))*100)));
                const modal_dist_peds = counts[0].peds.map((item,i) => ((item/(counts[0].active_travel[i] + counts[0].vehicles[i]))*100).toFixed(2) || 0);
                const modal_dist_bikes = counts[0].bikes.map((item,i) => ((item/(counts[0].active_travel[i] + counts[0].vehicles[i]))*100).toFixed(2) || 0);
                const modal_dist_vehicles = counts[0].vehicles.map((item,i) => ((item/(item + counts[0].active_travel[i]))*100).toFixed(2) || 0);

                const dataModal = {
                    labels: counts[0].date_iso || [],
                    datasets: [{
                        type: 'bar',
                        label: 'Pedestrians',
                        data: modal_dist_peds || [],
                        borderColor: chartColors[1],
                        backgroundColor: hex2rgba(chartColors[1], 0.5),
                        // borderColor:'rgba(255, 99, 132, 0.2)',
                        // backgroundColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        type: 'bar',
                        label: 'Bikes',
                        data: modal_dist_bikes || [],
                        borderColor: chartColors[5],
                        backgroundColor: hex2rgba(chartColors[5], 0.5),
                        // borderColor:'rgba(255, 99, 132, 0.2)',
                        // backgroundColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 2,
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        type: 'bar',
                        label: 'Vehicles',
                        data: modal_dist_vehicles || [],
                        borderColor: chartColors[4],
                        backgroundColor: hex2rgba(chartColors[4], 0.5),
                        // borderColor:'rgba(75, 192, 192, 0.2)',
                        // backgroundColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 2,
                        datalabels: {
                            display: false
                        }
                    }]
                }
                // console.log(data)
                setModalDist(dataModal);
            }
                
        }
        getVehicleCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[counts]);
    // VEHICLE COUNT END

    // Graph options
    const options = {
        maintainAspectRatio: false,
        legend: {
            display: false
        },
        scales: {
            y: { ticks: { beginAtZero: true } },
        },
        // plugins: { 
        //     datalabels: { display: false }
        // }
    };

    const options2 = {
        indexAxis: 'y',
    }

    const handleClearSearch = () => {
		setTimeFrom(new Date().setHours(0,0,0));
        setTimeTo(new Date().setHours(23,59,0));
		setAsset('');
		setDateSel(new Date());
		setDateSelTo(new Date());
        setCounts([]);
        setTotalCount({});
        setVehicleCount({});
        setBusiestDay({});
        setModalTotal({});
        setModalDist({});

        if (countryList.length === 1)
            setCountry(countryList[0]);
        else
            setCountry('');

        setLocation('');
        setError('');
    }

    const handleSearch = () => {
        if (asset){
            fetchCounts();
        }else{
            setError("Required");
        }
    }

    return (

        <div className="VehActiveTravel">
            <div className="col-md-12">
                <div className="row header">Vehicles v Active Travel</div>
            </div>
            {(!isLoading) ? (
            <div>
            <div className="col-md-12 pt-0 div-content">
            <div className="row">
                <div className="col-12 p-2 d-flex rounded bg-light">
                    <div className="col-8">
                    <div className="row">
                        <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-4">
                            <Form.Group controlId="country">
                                <Form.Label>Country</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={country}
                                    onChange={e => {setCountry(e.target.value)}}>
                                        <option value="">Country</option>
                                        {countryList.map((item, i) =>
                                            <option key={`country`+i} value={item}>{item}</option>
                                            )}

                                </Form.Control>
                            </Form.Group>
                            </div>
                            <div className="col-md-8">
                            <Form.Group controlId="location" >
                            <Form.Label>Location</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => {setLocation(e.target.value)}}>
                                        <option key='locs' value=''>Location</option>
                                        {locationList.map((item, i) =>
                                            <option key={`loc`+i} value={item}>{item}</option>
                                            )}
                                </Form.Control>
                            </Form.Group>
                            </div>
                            </div>
                            <Form.Group controlId="asset" >
                                <Form.Label>Asset</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={asset}
                                    onChange={e => {
                                        setError("");
                                        setAsset(e.target.value);}}
                                    >
                                    <option key='assetList' value=''>Select Asset</option>
                                    {assetList.map((item, i) =>
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                    )}
                                </Form.Control>
                                <div className="error-message">{error}</div>
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Group controlId="date_from" className="pb-2 mb-1">
                            <Form.Label><FaCalendarAlt className="text-secondary" /> Date From</Form.Label>
                            {/* <Form.Label><FaCalendarAlt className="text-secondary" /> Select Year(s)</Form.Label> */}
                            <div>
                            <DatePicker
                                dateFormat={formatDate[1]}
                                selected={dateSel}
                                onChange={(dateSel) => {setDateSel(dateSel)}}
                                minDate={new Date(moment().add(-6, 'month'))}
                                maxDate={new Date()}
                                className="form-control" />
                            </div>
                            </Form.Group>
                            <Form.Group controlId="date_from" className="pb-2 mb-1">
                            <Form.Label><FaCalendarAlt className="text-secondary" /> Date To</Form.Label>
                            <div>
                            <DatePicker
                                dateFormat={formatDate[1]}
                                selected={dateSelTo}
                                onChange={(dateSelTo) => {setDateSelTo(dateSelTo)}}
                                minDate={new Date(moment().add(-6, 'month'))}
                                maxDate={new Date()}
                                className="form-control" />
                            </div>
                            </Form.Group>

                        </div>
                        </div>
                    </div>
                    <div className="text-nowrap">

                        <Button variant="info" size="sm" onClick={handleSearch} className="mr-1 text-nowrap"
                        disabled = {isLoadingCounts? true : false}
                        >
                            <MdSearch /> Search
                        </Button>

                        <Button variant="danger" size="sm" onClick={handleClearSearch} >
                            <MdClear />
                        </Button>

                    </div>
                    <div className="w-100 text-right print">
                        <VehActiveTravelXls
                            totalCount={totalCount}
                            vehCounts={counts}
                            busiestDay={busiestDay}
                            modalTotal={modalTotal}
                            modalDist={modalDist}
                            numDays={numDays}
                            dateFrom={dateSel}
                            dateTo={dateSelTo}
                            asset={assetName}
                            />
                        <Button variant="light" size="sm" onClick={() => window.print()} >
                            <FaPrint /> Print
                        </Button>
                    </div>
                </div>
                </div>

                <div className="row p-2">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12 text-center">
                            {(isLoadingCounts) ? (
                            <>
                            <Spinner animation="grow" size="sm" role="status" variant="warning" />
                            <span className="text-secondary">  Loading...</span>
                            </>
                         ): ''}
                            </div>
                            <div className="col-md-4 pb-2 small text-right text-secondary">
                                {/* &nbsp;&nbsp;Last Update: {lastUpd} */}
                            </div>
                        </div>
                        <div className="row">
                            {(totalCount.datasets && totalCount.datasets.length > 0)?
                            <div className="col-md-12">
                                <h2>Within {numDays} days</h2>                          
                            </div>
                            :''}

                            {(totalCount.datasets && totalCount.datasets.length > 0)?
                            <div className="col-md-4 pb-3">                           
                            <h2 className="text-header">Vehicles vs Active Travel</h2>
                            <div className="text-description small pb-3">
                                total vehicle count over the selected period
                            </div>                           
                            <Graph
                                title="Vehicles vs Active Travel"
                                data={totalCount}
                                options={options}
                                site={assetName}
                            />
                            </div>
                            :''}

                            {(modalTotal.datasets && modalTotal.datasets.length > 0)?
                            <div className="col-md-4 pb-3">
                            <h2 className="text-header">Modal Split %</h2>
                            <div className="text-description small pb-3">
                                percentage of distribution for the selected period
                            </div>
                            <Graph
                                title="Modal Split %"
                                data={modalTotal}
                                options={options}
                                site={assetName}
                            />
                            </div>
                            :''}

                            {(busiestDay.datasets && busiestDay.datasets.length > 0)?
                            <div className="col-md-4 pb-3">
                            <h2 className="text-header">Busiest Day</h2>
                            <div className="text-description small pb-3">
                                total count on the busiest day
                            </div>
                            <Graph
                                title="Busiest Day"
                                data={busiestDay}
                                options={options2}
                                site={assetName}
                            />
                            </div>
                            :''}

                            {(vehicleCount.datasets && vehicleCount.datasets.length > 0)?
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Vehicle Count</h2>
                            <div className="text-description small pb-3">
                                total vehicle count per day for the selected period
                            </div>
                            <Graph
                                title="Vehicle Count"
                                data={vehicleCount}
                                options={options}
                                site={assetName}
                            />
                            </div>
                            :''}

                            {(modalTotalVeh.datasets && modalTotalVeh.datasets.length > 0)?
                            <div className="col-md-12 pb-3">
                            <h2 className="text-header">Modal Split by Class</h2>
                            <div className="text-description small pb-3">
                                percentage distribution by vehicle classification in the selected period
                            </div>
                            <Graph
                                title="Modal Split by Class %"
                                data={modalTotalVeh}
                                options={options}
                                site={assetName}
                            />
                            </div>
                            :''}

                            {(modalDist.datasets && modalDist.datasets.length > 0)?
                            <div className="col-md-12">
                            <h2 className="text-header">Modal Split Distribution %</h2>
                            <div className="text-description small pb-3">
                                percentage distribution per day for the selected period
                            </div>
                            <Graph
                                title="Modal Split Distribution %"
                                data={modalDist}
                                options={options}
                                site={assetName}
                            />
                            </div>
                            :''}

                        </div>
                    </div>
                </div>

            </div>
            </div>
            ):(
                <div className="col-md-12">
                <Spinner animation="grow" size="sm" role="status" variant="warning" />
                <span className="text-dark">  Loading...</span>
                </div>
                )}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(VehActiveTravel);


